import React from "react";
import { useLocation } from "react-router-dom";

import { useSetRecoilState } from "recoil";
import { modalState } from "lib/store/common";

import { Footer as FooterN } from "@atsent/components";

import "./Footer.scss";

export const Footer: React.FC = () => {
  const location = useLocation();
  const setModal = useSetRecoilState(modalState);
  if (location.pathname === "/sign-in" || location.pathname === "/sign-up") {
    return (
      <footer className={"Footer bgBlack ss"}>
        <section>
          <div className={"copyright"}>
            사업자등록번호 : 642-87-02235
            <span className={"bar"}> | </span>
            경기도 성남시 분당구 황새울로 335번길 10, 5층 540호
            <br />
            대표자 : 박헌영
            <span className={"bar"}> | </span>
            전화번호 : 031-709-5323
            <br />
            <br />
            ©onmydev Inc. All rights reserved.
          </div>
        </section>
      </footer>
    );
  }
  return (
    <FooterN
      clickPrivacyPolicy={() => setModal((_) => ({ ..._, pp: true }))}
      clickTerms={() => setModal((_) => ({ ..._, term: true }))}
    />
  );
};
